import { Injectable } from '@angular/core';
import { CreatedProfile } from 'src/app/models/createdProfile.model';
import { NotificationData } from 'src/app/models/notificationData.model';
import { Offer } from 'src/app/models/offer.model';
import { Profile } from 'src/app/models/profile.model';
import { Report } from 'src/app/models/report.model';

@Injectable({
  providedIn: 'root'
})
export class ObjSetterService {

  constructor() { }

  getProfileObj(profile: any){
    const profileObj = new Profile(
      profile.uid,
      profile.name,
      profile.short_name,
      profile.registration_date,
      {
        value: profile.type.value,
        avilable_offers: profile?.type?.avilable_offers,
        pakege: profile?.type?.pakege ? profile?.type?.pakege : null,
        avilable_special: profile?.type?.avilable_special ? profile?.type?.avilable_special : [],
        expired_date: profile?.type?.expired_date?.seconds ? new Date(profile?.type?.expired_date?.seconds * 1000) : profile?.type?.expired_date,
        order_id: profile?.type?.order_id ? profile?.type?.order_id : null
      },
      profile.status,
      profile.login_method,
      profile.num_offers,
      profile?.img_url,
      profile?.bio,
      profile?.email,
      profile?.phone,
      profile?.phone2,
      profile?.coordinates,
      profile?.country
    );
    return profileObj;
  }

  getCreatedProfileObj(createdProfile: any){
    const createdProfileObj = new CreatedProfile(
      createdProfile?.uid,
      createdProfile?.creater,
      createdProfile?.name,
      createdProfile?.short_name,
      createdProfile?.registration_date,
      createdProfile?.status,
      createdProfile?.num_offers,
      createdProfile?.img_url,
      createdProfile?.email,
      createdProfile?.phone,
      createdProfile?.phone2
    );
    return createdProfileObj;
  }

  getOffersObj(offer: any){
    const offerObj = new Offer(
      offer.id,
      offer.uid,
      offer.title,
      offer.short_title,
      offer.cover,
      offer.description,
      offer.oFor,
      offer.oType,
      offer.oUploader,
      offer.imgsUrl,
      {
        value: offer.price.value,
        currency: offer.price.currency
      },
      offer?.date?.seconds ? new Date(offer?.date?.seconds * 1000) : offer?.date,
      {
        value: offer.status.value,
        expired_date: offer?.status?.expired_date?.seconds ? new Date(offer?.status?.expired_date?.seconds * 1000) : offer?.status?.expired_date
      },
      offer.views,
      offer.coordinates,
      offer.address,
      {
        value: offer?.isSpecial?.value,
        expired_date: offer?.isSpecial?.expired_date?.seconds ? new Date(offer?.isSpecial?.expired_date?.seconds * 1000) : offer?.isSpecial?.expired_date,
        order_id: offer?.isSpecial?.order_id ? offer?.isSpecial?.order_id : null
      },
      offer?.createrForId,
      offer?.draw,
      offer?.details,
      offer?.g,
      offer?.distance
    );
    return offerObj;
  }

  getReportObj(reports: any){
    console.log('reports', reports);

      const reportsObj = new Report(
        reports.id,
        {
          id: reports.offer.id,
          status: reports.offer.status
        },
        reports.reportedId,
        reports.reporterId,
        reports.text,
        reports?.date?.seconds ? new Date(reports?.date?.seconds * 1000) : reports?.date,
        reports.states,
        reports.replay ? reports.replay : null,
        reports.created ? reports.created : null
      );
      return reportsObj;
  }

  getNotificationObj(notification: any){
    const notificationObj = new NotificationData(
      notification.title,
      notification.body,
      notification.img,
      new Date(notification.date.seconds*1000).toLocaleDateString("en-US"),
    );
    return notificationObj;
  }

  getProfileListObj(users: any[]){
    let returndData: Profile[] = [];
    users.forEach(user => {
      let data: Profile = null;
      data = this.getProfileObj(user);
      returndData.push(data);
    });
    return returndData;
  }

  getCreatedProfileListObj(users: any[]){
    let returndData: CreatedProfile[] = [];
    users.forEach(user => {
      let data: CreatedProfile = null;
      data = this.getCreatedProfileObj(user);
      returndData.push(data);
    });
    return returndData;
  }

  getOffersListObj(offers: any[]){
    let returndData: Offer[] = [];
    offers.forEach(ele => {
      let data: Offer = null;
      data = this.getOffersObj(ele);
      returndData.push(data);
    });
    return returndData;
  }

  getReportListObj(reports: any[]){
    let returndData: Report[] = [];
    reports.forEach(ele => {
      let data: Report = null;
      data = this.getReportObj(ele);
      returndData.push(data);
    });
    return returndData;
  }

  getNotificationListObj(notifications: any[]){
    let returndData: NotificationData[] = [];
    notifications.forEach(ele => {
      let data: NotificationData = null;
      data = this.getNotificationObj(ele);
      returndData.push(data);
    });
    return returndData;
  }
}
